export default "__VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__"